import * as React from 'react';
import { H6 } from '@shared/ui-components';

interface FaqItem {
  title: string;
  content: JSX.Element;
}

export function getFAQList(): FaqItem[] {
  return [
    {
      title: 'Can I have a free trial?',
      content: (
        <H6>Yes, you can have a free, full feature trial of the software.</H6>
      ),
    },
    {
      title: 'Would my credit card information be safe?',
      content: (
        // eslint-disable-next-line max-len
        <H6>Yes. We do NOT store your credit card information anywhere in our systems. All your credit card details are processed by Stripe, the global leader in online payment processing.</H6>
      ),
    },
    {
      title: 'Can I cancel my subscription?',
      content: (
        <H6>Yes, you can cancel your subscription any time.</H6>
      ),
    },
    {
      title: 'Can I renew my subscription?',
      content: (
        // eslint-disable-next-line max-len
        <H6>Sure. You can cancel and renew your subscription any time you need. Please, note that according to the platform's logic, your account will be charged in compliance with the chosen plan once pressing "Renew subscription" button.</H6>
      ),
    },
  ];
}
